var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeleport = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teleport"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M10.5 14.875L10.9688 18.7812C11.0469 19.4062 11.5938 19.875 12.2188 19.875H13.7422C14.3672 19.875 14.9141 19.4062 14.9922 18.7812L15.5 14.875C16.1641 14.875 16.75 14.3281 16.75 13.625V11.75C16.75 10.3828 15.6172 9.25 14.25 9.25H11.75C10.3438 9.25 9.25 10.3828 9.25 11.75V13.625C9.25 14.3281 9.79688 14.875 10.5 14.875ZM13 8C14.3672 8 15.5 6.90625 15.5 5.5C15.5 4.13281 14.3672 3 13 3C11.5938 3 10.5 4.13281 10.5 5.5C10.5 6.90625 11.5938 8 13 8ZM17.375 16.4375V18.2344C19.3672 18.4688 21.125 18.8594 21.125 19.5625C21.125 20.8125 16.0078 21.125 13 21.125C9.95312 21.125 4.875 20.8125 4.875 19.5625C4.875 18.8203 6.82812 18.4297 8.625 18.2344V16.4375C6.24219 16.7891 3 17.6094 3 19.5625C3 22.2969 9.25 23 13 23C16.7109 23 23 22.2969 23 19.5625C23 17.8047 20.2656 16.8672 17.375 16.4375Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeleport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/teleport.a8f0d572eb107cd29316072adb94e55f.svg";